<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-2">
        Déterminez la polarité relative des composés suivants (du moins au plus polaire)
      </p>

      <p class="pl-4 mb-6">
        <v-img style="max-width: 500px" :src="imageName" />
      </p>

      <drag-to-rank-input-fr
        v-model="inputs.relativePolarities"
        :items="items"
        class="mb-0"
        style="max-width: 512px"
        prepend-text="Le plus polaire"
        append-text="Le moins polaire"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import ChemicalLatex from '../displayers/ChemicalLatex';
import StembleLatex from '@/tasks/components/StembleLatex';
import DragToRankInputFr from '@/tasks/components/inputs/DragToRankInputFr.vue';
import {prefixPublicAsset} from '@/common/plugins/public-asset-plugin';

export default {
  name: 'uOttawa1321Prelab1Q3Fr',
  components: {
    DragToRankInputFr,
    ChemicalLatex,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        relativePolarities: [],
      },
      items: ['$\\text{Mol. A}$', '$\\text{Mol. B}$', '$\\text{Mol. C}$', '$\\text{Mol. D}$'],
    };
  },
  computed: {
    imageName() {
      return prefixPublicAsset('/img/assignments/rankPolarities1.png');
    },
  },
};
</script>
